export const environmentSDK =  {
  API_KEY: 'PBxc0p3bsb4E2gqSzx29oDwaBgQPFM377ASwIBic',
  CLIENT_ID: '3jesn042jsa8s4vbqmh55gbdmn',
  CLIENT_SECRET: '4vqr5kuiefmgajuvhmsnbq64ki2slr9kop4p3d6c9h9krfctiqt',
  PRODUCTION: false,
  ENTITY_ID: '31',
  PROCEDURE_ID: 109,
  APP_IDENTIFIER: 'com.bsccolombia.vinculaciones',
  ENDPOINT_AUTH:'https://api.soyyo.mobi/oauth2/token',
  ENDPOINT_ACTIVATION: 'https://api.soyyo.mobi/snb-enrollment-process/enrollment-process/v2.0/userActivation/WEB_CLIENT',
  ENDPOINT_VALIDATION: 'https://api.soyyo.mobi/snb-user/user/v2.1/users/validate'
}